import React from "react";
import AiTeamDropDown from "../../Components/AiTeamDropDown";
import { ReactComponent as CameraIcon } from "../../Assets/Icons/cameraIcon.svg";
import CloseIcon from "../../Assets/Icons/closeIcon.svg";
import CoverImg from "../../Assets/CoverImg.png";
import TeamImg from "../../Assets/TeamProfile.png";

export default function AiTeamSideBar({ setOpenModal }) {
  return (
    <div
      style={{
        boxShadow:
          "0px 4px 6px 0px rgba(0, 0, 0, 0.05), 0px 10px 15px -3px rgba(0, 0, 0, 0.10)",
      }}
      className="w-[752px] px-5 py-3 bg-white fixed right-0 top-0 z-50 h-screen overflow-y-scroll overflow-x-hidden"
    >
      <div className="flex items-center justify-between">
        <p className="text-[1.1rem] text-[#111928] font-[600]">
          Edit Al in Workforce Development Team
        </p>
        <img
          className="cursor-pointer"
          src={CloseIcon}
          onClick={() => setOpenModal(false)}
        />
      </div>
      <div className="w-full h-[1px] bg-[#D1D5DB] mt-2"></div>
      <div
        style={{ backgroundImage: `url(${CoverImg})` }}
        className="w-full h-[14rem] bg-no-repeat bg-cover bg-center rounded-[8px] flex items-start justify-end p-3 mt-3"
      >
        <CameraIcon stroke="black" />
      </div>
      <div className="flex items-center justify-center mt-[-70px]">
        <div
          style={{ backgroundImage: `url(${TeamImg})` }}
          className="w-[10rem] h-[10rem] bg-no-repeat bg-cover rounded-[8px] flex items-center justify-center pt-28 p-3"
        >
          <CameraIcon stroke="white" />
        </div>
      </div>
      <div className="flex flex-col gap-4">
        <div className="flex items-start flex-col gap-1">
          <label className="text-[0.95rem] text-[#111928] font-[500]">
            Team Name
          </label>
          <input
            className="w-[710px] h-[2.6rem] border-[1px] border-[#D1D5DB] bg-[#F9FAFB] text-[0.90rem] text-[#6B7280] pl-3 outline-none rounded-[8px]"
            type="text"
            placeholder="Riyadh Global Al Corridor Team"
          />
        </div>
        <div className="flex items-start flex-col gap-1">
          <label className="text-[0.95rem] text-[#111928] font-[500]">
            Location
          </label>
          <input
            className="w-[710px] h-[2.6rem] border-[1px] border-[#D1D5DB] bg-[#F9FAFB] text-[0.90rem] text-[#6B7280] pl-3 outline-none rounded-[8px]"
            type="text"
            placeholder="Riyadh"
          />
        </div>
        <div className="flex items-start flex-col gap-1">
          <label className="text-[0.95rem] text-[#111928] font-[500]">
            Description
          </label>
          <textarea
            placeholder="Describe your AI team here. What are your team's specialties? What innovative projects have you worked on? Help others understand your team's skills, passions, and accomplishments."
            className="w-[710px] h-[9.6rem] border-[1px] border-[#D1D5DB] bg-[#F9FAFB] text-[0.90rem] text-[#6B7280] pl-3 outline-none rounded-[8px] pt-2 px-2 resize-none"
          ></textarea>
        </div>
        <button className="w-[710px] h-[2.5rem] rounded-[8px] text-[0.90rem] text-white font-[500] border-[1px] border-[#942A27] flex items-center justify-center gap-2 bg-[#942A27]">
          Save
        </button>
      </div>
    </div>
  );
}
